var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app-footer"},[_c('div',[_vm._v("© 2026 北京银合信科技有限公司. 保留所有权利.")]),_c('a',{attrs:{"href":"https://www.yinhexin.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("京ICP备2023003240号")])])
}]

export { render, staticRenderFns }